import Service from '@ember/service';

import { service } from '@ember/service';
import { storageFor } from 'ember-local-storage';

import { get } from 'rise-ui/utils/object.js';

const configKey = 'debug.contact';
const dryRunKey = `${configKey}.dryRun`;

export default class ContactDebugService extends Service {
  @service router;
  @storageFor('debug') debug;

  get dryRun() {
    return get(this, dryRunKey) || false;
  }
}
